import { useNavigate } from 'react-router-dom';
import styles from './NotFound.module.scss';

const NotFound = () => {
	const navigate = useNavigate();
	return (
		<div className={styles.notFound}>
			<h3>Oops! Looks like you took a wrong turn.</h3>
			<button onClick={() => navigate(-1)}>Go Back</button>
		</div>
	);
};
export default NotFound;
